import CollectionsIcon from '@mui/icons-material/Collections';
import { useState } from 'react';

import { EstadosImagenChoiceEnum } from '@/shared';
import { SingleIconButton } from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import ActualizarFotosEntradaTecOTModal from './ActualizarFotosEntradaTecOTModal';
import ActualizarFotosSalidaTecOTModal from './ActualizarFotosSalidaTecOTModal';

export type ActualizarFotosTecnicoOTCellProps = {
  ordenTrabajo: OrdenTrabajo;
};

const ActualizarFotosTecnicoOTCell: React.FC<
  ActualizarFotosTecnicoOTCellProps
> = ({ ordenTrabajo }) => {
  const [isOpenFotosEntradaModal, setIsOpenFotosEntradaModal] = useState(false);
  const [isOpenFotosSalidaModal, setIsOpenFotosSalidaModal] = useState(false);

  return (
    <>
    {/* <p>{ordenTrabajo?.estado_imagen_actualizacion}</p> */}
      {/* ========= btns ========= */}
      {ordenTrabajo?.estado_imagen_entrada ==
        EstadosImagenChoiceEnum.UPD_SOLICITADA && (
        <SingleIconButton
          startIcon={<CollectionsIcon />}
          color="secondary"
          label={'Actualizar Fotos Entrada'}
          onClick={() => {
            setIsOpenFotosEntradaModal(true);
          }}
        />
      )}

      {ordenTrabajo?.estado_imagen_salida ===
        EstadosImagenChoiceEnum.UPD_SOLICITADA && (
        <SingleIconButton
          startIcon={<CollectionsIcon />}
          color="primary"
          label={'Actualizar Fotos Salida'}
          onClick={() => {
            setIsOpenFotosSalidaModal(true);
          }}
        />
      )}

      {/* ========= Modals ========= */}
      <ActualizarFotosEntradaTecOTModal
        ordenTrabajo={ordenTrabajo!}
        open={isOpenFotosEntradaModal}
        onClose={() => {
          setIsOpenFotosEntradaModal(false);
        }}
      />

      <ActualizarFotosSalidaTecOTModal
        ordenTrabajo={ordenTrabajo}
        open={isOpenFotosSalidaModal}
        onClose={() => {
          setIsOpenFotosSalidaModal(false);
        }}
      />
    </>
  );
};

export default ActualizarFotosTecnicoOTCell;
